import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { defineLocale, formatDate, ptBrLocale } from 'ngx-bootstrap/chronos';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { ProjetoConstant } from '../../../constants/projeto.constant';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { ProjetoCadastro } from '../../../models/projeto-cadastro.model';
import { ProjetoCadastroService } from '../../../services/projeto-cadastro.service';
import { environment } from 'src/environments/environment';

defineLocale('pt-br', ptBrLocale);

@Component({
  selector: 'app-projeto-edit',
  templateUrl: './projeto-edit.component.html',
  styleUrls: ['./projeto-edit.component.scss'],
})
export class ProjetoEditComponent
  extends BaseFormComponent<ProjetoCadastro>
  implements OnInit
{
  actionLabel: string = 'Novo';
  filters: any;
  modalProblemRef?: BsModalRef;
  modalCloneRef?: BsModalRef;
  modalLinkRef?: BsModalRef;
  question: any;
  disabledBtn: boolean = true;
  clone_title: string;
  constant = ProjetoConstant;
  lastTabGroupName: string = '';
  audit: AtualizacoesAudit;

  @ViewChild('modalLink') modalLink: TemplateRef<any>;
  @ViewChild('modalProblem') modalProblem: TemplateRef<any>;
  @ViewChild('modalClone') modalClone: TemplateRef<any>;

  constructor(
    private myService: ProjetoCadastroService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private modalService: BsModalService,
    private router: Router,
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.filters = this.activatedRoute.snapshot.data['filters'];
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl(null, [Validators.required, Validators.maxLength(300)]),
      agency_id: new FormControl({ value: this.filters?.agencySelect, disabled: this.entity?.id }, [Validators.required]),
      situation_id: new FormControl(null),
      manager: new FormControl(null),
      adjunct: new FormControl(null),
      plan_aproved: new FormControl(null, this.entity?.id ? [Validators.required] : []),
      ds_problem: new FormControl(null, [Validators.maxLength(2500)]),
      ds_problem2: new FormControl(null, [Validators.maxLength(3000)]),
      ds_problem_result: new FormControl(null, Validators.maxLength(2500)),
      ds_problem_cause: new FormControl(null, [Validators.maxLength(2500)]),
      ds_problem_evidence: new FormControl(null, [Validators.maxLength(2500)]),
      ds_object: new FormControl(null, [Validators.maxLength(500)]),
      ds_objective: new FormControl(null, [Validators.maxLength(2500)]),
      ds_reason: new FormControl(null, [Validators.maxLength(3000)]),
      ds_impact_society: new FormControl(null, [Validators.maxLength(3000)]),
      ds_benchmark: new FormControl(null, [Validators.maxLength(3000)]),
      ds_target: new FormControl(null, Validators.maxLength(1000)),
      tot_direct_ben: new FormControl(null, this.entity?.id ? [Validators.required, Validators.maxLength(10)] : []),
      ds_indirect_ben: new FormControl(null, [Validators.maxLength(1000)]),
      tot_indirect_ben: new FormControl(null, this.entity?.id ? [Validators.required, Validators.maxLength(10)] : []),
      local_exec_type: new FormControl(null, this.entity?.id ? [Validators.required] : []),
      cityexec: new FormArray([new FormControl(null)]),
      coredeexec: new FormArray([new FormControl(null)]),
      rfexec: new FormArray([new FormControl(null)]),
      cityben: new FormArray([new FormControl(null)]),
      coredeben: new FormArray([new FormControl(null)]),
      rfben: new FormArray([new FormControl(null)]),
      local_ben_type: new FormControl(null, this.entity?.id ? [Validators.required] : []),
      exec_duration: new FormControl(null, [Validators.maxLength(10)]),
      cost_total: new FormControl(null, this.entity?.id ? [Validators.required, Validators.maxLength(10)] : []),
      process_id: new FormControl(null),
      questions: new FormArray([]),
    });

    if (this.entity?.id) {
      this.actionLabel = 'Editar';
      this.audit = {
        pp_id: this.entity?.id,
      };
      this.form.patchValue(this.entity);
      this.populateFields();
      this.disabledBtn = this.entity?.can_save && !this.entity?.readonly;
      if (this.entity?.readonly) this.form.disable();
    }
  }

  populateFields() {
    this.populateList('coredeben', 'corede_id');
    this.populateList('coredeexec', 'corede_id');
    this.populateList('rfben', 'rf_id');
    this.populateList('rfexec', 'rf_id');
    this.populateList('cityben', 'city_id');
    this.populateList('cityexec', 'city_id');

    if (this.entity?.manager && this.entity?.managerList?.length) {
      this.filters.personList.push(...this.entity.managerList);
    }
    if (this.entity?.adjunct && this.entity?.adjunctList?.length) {
      this.filters.personList.push(...this.entity.adjunctList);
    }

    if (this.entity?.questions?.length) {
      const formGroup = {};
      this.entity.questions.forEach((field) => {
        formGroup[field.question_id] = new FormGroup({
          question_id: new FormControl(field.question_id),
          ds_value: new FormControl(field.ds_value),
        });
      });

      this.getFormArray('questions').push(new FormGroup(formGroup));
    }
  }

  populateList(formArrayName: string, idFieldName: string) {
    if (this.entity?.[formArrayName]?.length) {
      this.getFormArray(formArrayName).clear();
      this.entity[formArrayName].forEach((item) => {
        this.getFormArray(formArrayName).push(
          new FormControl(item[idFieldName])
        );
      });
    }
  }

  getFormArray(form: string): FormArray {
    return this.form.get(form) as FormArray;
  }

  getControl(form: string) {
    const formGroup = this.getFormArray('questions').at(0)?.['controls']?.[form] as FormGroup;
    return formGroup?.get('ds_value');
  }

  addField(form: string) {
    this.getFormArray(form).push(new FormControl(null));
  }

  removeField(index: number, form: string) {
    this.getFormArray(form).removeAt(index);
  }

  voltar() {
    this.navigation.back(['/pre-projeto', 'projeto']);
  }

  getDataCreate(): ProjetoCadastro {
    let data: ProjetoCadastro = { ...this.form.value };

    if (this.entity?.questions) {
      this.entity.questions.forEach((field) => {
        if (field.type_id == this.filters?.ppQuestion['TYPE_DATA']) {
          const formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
          const dataSimples = this.getControl(field.question_id)?.value;
          if (dataSimples && !formatoDataRegex.test(dataSimples)) {
            data.questions[0][field.question_id].ds_value = formatDate(
              dataSimples,
              'DD/MM/YYYY'
            );
          }
        }
      });
      data.questions = data.questions[0];
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.create(this.getDataCreate()).subscribe({
          next: (res) => {
            this.confirmation().subscribe(() => {
              this.navigation.replace(['/pre-projeto', 'projeto', res.id]);
            });
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  update(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id && this.entity?.can_save) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.entity.id)
            .subscribe({
              next: (res) => {
                this.confirmation('Cadastro alterado com sucesso!').subscribe(() => {
                  this.loaded();
                  window.location.reload();
                });
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  entityRefresh() {
    this.addSub(
      this.myService.getById(this.entity?.id).subscribe({
        next: (res) => {
          this.entity = res;
          this.initForm();
          this.loaded();
        },
        error: (erro) => {
          this.msgError(erro?.message);
          this.loaded();
        },
      })
    );
  }

  fieldMessageRequireds(form: string): boolean {
    return this.getControl(form)?.invalid && this.getControl(form)?.dirty;
  }

  fieldErrosFormArray(form: string) {
    return this.getControl(form)?.errors;
  }

  clearInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    input.value = '';
  }

  formatarMedidaFisica(field: string, decimal: number = 2) {
    let value = this.maskService.formatarMedidaFisica(
      this.form.get(field)?.value,
      decimal
    );
    this.form.get(field).setValue(value);
  }

  formatarMedidaFisica2(form, decimal = 2) {
    let value = this.maskService.formatarMedidaFisica(
      this.getControl(form)?.value,
      decimal
    );
    this.getControl(form)?.setValue(value);
  }

  shouldShowHeader(currentTabGroupName: string, index: number): boolean {
    if (index === 0 || currentTabGroupName !== this.lastTabGroupName) {
      this.lastTabGroupName = currentTabGroupName;
      return true;
    }
    return false;
  }

  confirmExcluir() {
    this.alertConfirmation(null, 'Tem certeza que deseja excluir o projeto?').subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: () => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'projeto']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error);
      },
    });
  }

  closeProblemModal() {
    this.modalProblemRef?.hide();
  }

  openProblemModal() {
    this.modalProblemRef = this.modalService.show(this.modalProblem, {
      class: 'modal-xl',
    });
    this.form.get('ds_problem2').setValue(this.form.get('ds_problem').value);
  }

  saveProblemModal() {
    this.form.get('ds_problem').setValue(this.form.get('ds_problem2').value);
    this.closeProblemModal();
  }

  closeLinkModal() {
    this.modalLinkRef?.hide();
  }

  openLinkModal() {
    this.modalLinkRef = this.modalService.show(this.modalLink, {
      class: 'modal-xl modal-top',
    });
  }

  closeCloneModal() {
    this.modalCloneRef?.hide();
  }

  openCloneModal() {
    this.clone_title = '';
    this.modalCloneRef = this.modalService.show(this.modalClone);
  }

  clonar() {
    this.closeCloneModal();
    this.loading();
    if (this.entity?.id && this.entity?.can_clone) {
      const obj = {
        clone_id: this.entity.id,
        clone_title: this.clone_title,
      };
      this.addSub(
        this.myService.clonar(obj).subscribe({
          next: (res) => {
            this.entity.id = res?.id;
            this.confirmation('Clonado com sucesso!').subscribe(() => {
              this.router.navigate(['/pre-projeto', 'projeto', res?.id, 'cadastro']).then(() => {
                this.entityRefresh();
                this.loaded();
              });
            })
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  imprimir() {
    this.loading();
    const url = `${environment.serverUrl}/rest/pre-projeto/relatorio/${this.entity?.id}`;
    this.loaded();
    window.open(url, '_blank');
  }
}
